import { IconProps } from "../../utils/global-types/global-types";

const SalesIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className}
    {...rest}
  >
    <g clipPath="url(#clip0_4130_53467)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M10.493 3.811C8.611 6.585 5.124 7.485 5.124 7.485a.5.5 0 0 1-.248-.969s3.321-.842 4.944-3.507L8.837 3a.5.5 0 0 1 .009-1l2.14.02a.5.5 0 0 1 .495.495l.019 2.09a.5.5 0 0 1-1 .01zm-4.25 12.19H4a1 1 0 0 1-1-1v-4.5a1 1 0 0 1 1-1h2.242zm1-6.983C7.242 8.456 7.697 8 8.26 8h1.438c.563 0 1.018.456 1.018 1.018V16H7.242zm4.473-2c0-.562.456-1.018 1.017-1.018H14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.284z"
        clipRule="evenodd"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_4130_53467">
        <path fill="#fff" d="M0 0h18v18H0z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default SalesIcon;
